
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as advigNTQPqtkkbGRwyl0a4_455v51vL55vYIX7GeQ8tFw5z4Meta } from "/app/pages/adv.vue?macro=true";
import { default as base_n0ylgUvmlXk0mTZazW_45oRalQXeHT0knUMyJoHdvySYMeta } from "/app/pages/base.vue?macro=true";
import { default as cartbqvKlr4P3KWVI39lVm4PanL_ftLfoLwpA5GLzZKyC94Meta } from "/app/pages/cart.vue?macro=true";
import { default as helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta } from "/app/pages/help.vue?macro=true";
import { default as main0XP8SEg1cxsSzo_451msNZGyXISQ4_45WE5ZuxIOl8IqIRQMeta } from "/app/pages/main.vue?macro=true";
import { default as newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta } from "/app/pages/news.vue?macro=true";
import { default as about3BeDYJHafdz3_450F8I84XDeTlPVmsANEPp0qlI_45udm9EMeta } from "/app/pages/about.vue?macro=true";
import { default as emailVN0QQ2utdtmgjKFQsaDnNG6O1Dx9xbt5J_1xPn9yo9gMeta } from "/app/pages/email.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as sergeyF7Y7NctkYggi6k_45jN6wRRz7sbutoqjZYg0ogOTlWKUIMeta } from "/app/pages/sergey.vue?macro=true";
import { default as appealsWSl18hJGK3gNP3s1a0gYZQr_45T3vYIbgjaTBQfnV0pEsMeta } from "/app/pages/appeals.vue?macro=true";
import { default as balance_U0WLV9gjfU_52l6XiH5Iv83_45RKT0g1c1zZ69yLiKv4Meta } from "/app/pages/balance.vue?macro=true";
import { default as catalogLWWEIG0_45f7N2q2COWPs96jHzhShznO5jhI3mJ2jQoTsMeta } from "/app/pages/catalog.vue?macro=true";
import { default as _91id_93Bn0vOcYiR8oG_45wz5jSvAcn3gWscC0CCUReO8Z_wRKGsMeta } from "/app/pages/ch/[id].vue?macro=true";
import { default as depositOOr1YqjH_45FaF7ffvzWRFaQuSfoOu0pT8Ujj7QoFtwK0Meta } from "/app/pages/deposit.vue?macro=true";
import { default as _91url_93DZRaPMoPov5U9_455d3wcgr_45jEBoVULidKsdgNBWPxYSMMeta } from "/app/pages/s/[url].vue?macro=true";
import { default as supporta84A2tb9xESxO6bOKWmFoDLo2va0te5rR2kefeEwfjUMeta } from "/app/pages/support.vue?macro=true";
import { default as _91id_93_oldd1MyzyBy2QTdm_AbsO9XxpkETcP8DzyOVCb29sgLcmMMeta } from "/app/pages/[id]_old.vue?macro=true";
import { default as maxooUJ6d7GyTcI5f_452D9a9cBgkXfnY5XGdUxaln8pg58QMeta } from "/app/pages/blog/max.vue?macro=true";
import { default as contactskxHN03Gsdgdk5hItUiIn_45VHejdeYe8Yz7_45onvuu94gkMeta } from "/app/pages/contacts.vue?macro=true";
import { default as settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta } from "/app/pages/settings.vue?macro=true";
import { default as creativesCcwilFM2alSEmMCxaUBSgcH14wtIkvN6Tu4xgpmFjj8Meta } from "/app/pages/creatives.vue?macro=true";
import { default as documentsnySbyr2WnGLxD8HHuPmsjpznGSLSMl3b7IkVDraAXt8Meta } from "/app/pages/documents.vue?macro=true";
import { default as favorites2sDHZ4tGgk4k1D69yU7rUnd6f57vi1WIDQHWhToa0iMMeta } from "/app/pages/favorites.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as indexIh3MXyNgRITOpI1vGt16ATsMaILQxMCLyDa1g3F64tcMeta } from "/app/pages/order/index.vue?macro=true";
import { default as _91id_93z_45mKuW1rMZYIKaD_45jb7RkOPiwtU5vi28dxEw6FTfUakMeta } from "/app/pages/orders/[id].vue?macro=true";
import { default as indexolbdBLy3g7xtsrzI2mgg0ddKLEKAVrXPnt4rQtd_KkoMeta } from "/app/pages/place/index.vue?macro=true";
import { default as _91url_93_oldjgWxgW3eeLF32BR6JiUPM3XDCvaqMrBoeeRg94_ujHcMeta } from "/app/pages/s/[url]_old.vue?macro=true";
import { default as previewWYqyYD2oTMwbVyIPiIzmtWIwierP7frgw7UvEvvqpUQMeta } from "/app/pages/blog/preview.vue?macro=true";
import { default as indexDCqhPzutOZTeEBErhbpXyxz9LSZCrOqFoLSpaIOOmIIMeta } from "/app/pages/orders/index.vue?macro=true";
import { default as confirmERmiYriC4CaDnGQgJ_iqfghuOKXlfyGDGRPP_45G4mtr0Meta } from "/app/pages/user/confirm.vue?macro=true";
import { default as index3CFDFRjJsl9ctqYPYF22Gk2o_3mqxoa_9l0TlY2b4CMMeta } from "/app/pages/_orders/index.vue?macro=true";
import { default as _91id_933X8Z25xS0KUIdu2rlGSIczgX6SnqvonrtZMgLVlcj4AMeta } from "/app/pages/creative/[id].vue?macro=true";
import { default as indexpSvHlw64TW_BPwpK8c1h6H_fbW0yNr0EE8HM_hg4Zj0Meta } from "/app/pages/dialogs/index.vue?macro=true";
import { default as notificationsB9uD7vf6BNbcGL3D9HpazycZMRkcPWG6ea6_45mQfWSE0Meta } from "/app/pages/notifications.vue?macro=true";
import { default as _91tag_93q4N3T4f_iz38MTuCeg6TYdTuUhYUWGAaPySsfR9ZBQMMeta } from "/app/pages/blog/tag/[tag].vue?macro=true";
import { default as indexbOdD09A79oK1qVLkrtsUVHiAyWrKXqI1cXPHgoHOekkMeta } from "/app/pages/creative/index.vue?macro=true";
import { default as createBtuz5zgwNAwb4rF0bvPzTxCpp2HfyypdqriW2wDyg5QMeta } from "/app/pages/creative/create.vue?macro=true";
import { default as indexUGzbRlCPmVAe4lGIxwXECpgBkYjPwkdrBYHUYSsPeykMeta } from "/app/pages/publisher/index.vue?macro=true";
import { default as indexiLUglNtYLLkYBTgKzOMogJCcAwTQAwliOX032oeizFUMeta } from "/app/pages/moderation/index.vue?macro=true";
import { default as importZYrg9WXs0rincSYGAC5rSs_9H9b4Zs9TvWvx7TQGfwkMeta } from "/app/pages/moderation/import.vue?macro=true";
import { default as ordersTJ5lhRrhxo4tppjn6jK9tY4_45PlFuzNYmOvjABDC7n6gMeta } from "/app/pages/moderation/orders.vue?macro=true";
import { default as reportsHtzF6M_45xY_458i2RnZKnVGRzA2fOgbEaPy4IbGA1A5QdUMeta } from "/app/pages/publisher/reports.vue?macro=true";
import { default as indexn_45IvwVXK1Vu7q21IzGfCgxkWV5wV5k93rFwvup2YmnEMeta } from "/app/pages/_orders/[id]/index.vue?macro=true";
import { default as indexU901K5DcjV_dvHvA3gFJtzxdVo9eXUOochoeglsScCYMeta } from "/app/pages/blog/[topic]/index.vue?macro=true";
import { default as clients0BJorUMbbEvYq15HRRy_Nx5zCncKTp0QXU2l4DWKT0sMeta } from "/app/pages/moderation/clients.vue?macro=true";
import { default as supportMehGf6oaYgppCAzOxOV_r0i3dDpQn9R_45QHpyvbDdKowMeta } from "/app/pages/moderation/support.vue?macro=true";
import { default as faqg1pAO7YqXFqKt7XFsc89GHwhwz_45Wf0mPoZ5QKJg0wdQMeta } from "/app/pages/publisher/help/faq.vue?macro=true";
import { default as _91slug_938Rk9ZzJ_fDkeYKZDqJOVvBdGDUOQCqL_45clYr2TrZWEMMeta } from "/app/pages/blog/[topic]/[slug].vue?macro=true";
import { default as channelsT3VIocaW116Kg0ADfvdQGsNgKQhH4sTsptKUv7A0gccMeta } from "/app/pages/moderation/channels.vue?macro=true";
import { default as settingsymxf2qVwUUMp5ti_egOwPxuQad5mRQ4CePdjstE3daMMeta } from "/app/pages/moderation/settings.vue?macro=true";
import { default as documents_45ulmJGPOrCWDHDH42h42o_G2NUlfNVO3SWaJBrgBwEMMeta } from "/app/pages/publisher/documents.vue?macro=true";
import { default as place_oldUpwIypj7KIqB_45JRy3cwlp7VTlviO7q2zp30Z_vJK_45BoMeta } from "/app/pages/publisher/place_old.vue?macro=true";
import { default as _91id_93ycopz8Vz8fiia40_45oRnP1r9rz4KjIPTo3zcCoZNMpCwMeta } from "/app/pages/_group/telegram/[id].vue?macro=true";
import { default as _91id_932NIs7a5h6QK_45L90AU2kQI0NUqPlTztSYcH6cPv6OzLwMeta } from "/app/pages/moderation/blog/[id].vue?macro=true";
import { default as indexGNEYi8DKtgjapm5uYfcQ819SwKQy673ZXWphBG6A4EUMeta } from "/app/pages/publisher/help/index.vue?macro=true";
import { default as _91id_93f5DjlbIbD_45W_45pSXH0faH01nDVgR9Fi_jeKisvLwsU7oMeta } from "/app/pages/publisher/place/[id].vue?macro=true";
import { default as newrz9bTu80Nhn_cPoSCYnE86BfYKc6VSM77tbQ9QbLHtEMeta } from "/app/pages/publisher/places/new.vue?macro=true";
import { default as placeScriptjOsddTL1jdX7CEjJgcHOll3LuuAQQwfK_45HMe_B5BrhoMeta } from "/app/pages/publisher/placeScript.ts?macro=true";
import { default as indexGv1nHhfou4GIGX5gNZ6dfaL3H7kY4_RreyMhVeJmgKIMeta } from "/app/pages/moderation/blog/index.vue?macro=true";
import { default as publishersvAeexi2WNvEASmpN404DWqY0l2ACHbanZMhWlha4UkUMeta } from "/app/pages/moderation/publishers.vue?macro=true";
import { default as statisticsbpVrq1O18hiDWUOB_7JWPbvs0V5ual5DRbty5z5Ssi4Meta } from "/app/pages/moderation/statistics.vue?macro=true";
import { default as MobilePlacejpk37MEsyCQAmVPFlNrBZdCzC5bsgGIlbC_45nb5JqT7YMeta } from "/app/pages/publisher/MobilePlace.vue?macro=true";
import { default as _91id_93Zk2eiLyYiQ7E_OFqPzyvRaiNIRromYuWfwy_ltPunGwMeta } from "/app/pages/publisher/places/[id].vue?macro=true";
import { default as createqFPXYwW0Kwp0okWKf7i5qfmaBGs5WWL6mSVd7q2A33oMeta } from "/app/pages/moderation/blog/create.vue?macro=true";
import { default as indextN5BIqHGXBtDuFonHrfZ9ghgDPOEluY37CWqbNDuTdgMeta } from "/app/pages/publisher/orders/index.vue?macro=true";
import { default as payments_old0dYMacFkybZ0gX2FlRDRsWB5BgFJDwPt32XuqB9_lXgMeta } from "/app/pages/publisher/payments_old.vue?macro=true";
import { default as publicationsgfwWaW7dSexGhko9MF2yUJnW9oCs_45Ti0IcxYj6_jzGQMeta } from "/app/pages/publisher/publications.vue?macro=true";
import { default as oldzGIGdtFEORuGvRsQJDNUwZOea2PcgFOdUkAQdVHOVHQMeta } from "/app/pages/publisher/showcase/old.vue?macro=true";
import { default as publicationsE_45E0N5dgTdZhiIx_R_45upEkVuBwZz9cZkcV52NIqnS2MMeta } from "/app/pages/moderation/publications.vue?macro=true";
import { default as indexzREiHP2_TsMlPdg1F7Iv2H2pptAFVrNTwy97Vo9_VDQMeta } from "/app/pages/publisher/dialogs/index.vue?macro=true";
import { default as indexNgs35_JaCzNSO_453Xnhhb7_45NAfWnaBdt8CCZ83BCSDIYMeta } from "/app/pages/publisher/history/index.vue?macro=true";
import { default as old_45idQ_45jFFVhKy9Myc_45kRvS3idq8ohJbZ0K6I9FvEYKe2sL8Meta } from "/app/pages/publisher/places/old-id.vue?macro=true";
import { default as index4CRes96f_ra5Nmtye_45Ede0lRjWotGmRQNt8U7wg_ARsMeta } from "/app/pages/publisher/payments/index.vue?macro=true";
import { default as indexc5LIbfF4Qy_swRc1d5HVVew6QKYqqr0lfoVGFG1YA0sMeta } from "/app/pages/publisher/settings/index.vue?macro=true";
import { default as indexkDPyChnYWolx9oP4JndGYB0CxLNse3ONY_45rj3qsePgoMeta } from "/app/pages/publisher/showcase/index.vue?macro=true";
import { default as publicS2Lj7zu_45D7BBjYp6ykDlHmsCE6ZhAhMQG9OsJfhUJ7QMeta } from "/app/pages/publisher/showcase/public.vue?macro=true";
import { default as index_oldJ3Js1tlNsFuqAtOQn6GZ9otTAYu1EFDTZrSbiWs9ZTMMeta } from "/app/pages/publisher/showcase/index_old.vue?macro=true";
import { default as _91id_93P2H4TrB53Lv44xyYMsh6sBz5mCJgZg22L_pVR7ydRRUMeta } from "/app/pages/publisher/places/moderate/[id].vue?macro=true";
export default [
  {
    name: "adv",
    path: "/adv",
    component: () => import("/app/pages/adv.vue")
  },
  {
    name: "base",
    path: "/base",
    meta: base_n0ylgUvmlXk0mTZazW_45oRalQXeHT0knUMyJoHdvySYMeta || {},
    component: () => import("/app/pages/base.vue")
  },
  {
    name: "cart",
    path: "/cart",
    meta: cartbqvKlr4P3KWVI39lVm4PanL_ftLfoLwpA5GLzZKyC94Meta || {},
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "help",
    path: "/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "main",
    path: "/main",
    component: () => import("/app/pages/main.vue")
  },
  {
    name: "news",
    path: "/news",
    meta: newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta || {},
    component: () => import("/app/pages/news.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: about3BeDYJHafdz3_450F8I84XDeTlPVmsANEPp0qlI_45udm9EMeta || {},
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "email",
    path: "/email",
    component: () => import("/app/pages/email.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "sergey",
    path: "/sergey",
    component: () => import("/app/pages/sergey.vue")
  },
  {
    name: "appeals",
    path: "/appeals",
    meta: appealsWSl18hJGK3gNP3s1a0gYZQr_45T3vYIbgjaTBQfnV0pEsMeta || {},
    component: () => import("/app/pages/appeals.vue")
  },
  {
    name: "balance",
    path: "/balance",
    meta: balance_U0WLV9gjfU_52l6XiH5Iv83_45RKT0g1c1zZ69yLiKv4Meta || {},
    component: () => import("/app/pages/balance.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    meta: catalogLWWEIG0_45f7N2q2COWPs96jHzhShznO5jhI3mJ2jQoTsMeta || {},
    component: () => import("/app/pages/catalog.vue")
  },
  {
    name: "ch-id",
    path: "/ch/:id()",
    meta: _91id_93Bn0vOcYiR8oG_45wz5jSvAcn3gWscC0CCUReO8Z_wRKGsMeta || {},
    component: () => import("/app/pages/ch/[id].vue")
  },
  {
    name: "deposit",
    path: "/deposit",
    meta: depositOOr1YqjH_45FaF7ffvzWRFaQuSfoOu0pT8Ujj7QoFtwK0Meta || {},
    component: () => import("/app/pages/deposit.vue")
  },
  {
    name: "s-url",
    path: "/s/:url()",
    meta: _91url_93DZRaPMoPov5U9_455d3wcgr_45jEBoVULidKsdgNBWPxYSMMeta || {},
    component: () => import("/app/pages/s/[url].vue")
  },
  {
    name: "support",
    path: "/support",
    meta: supporta84A2tb9xESxO6bOKWmFoDLo2va0te5rR2kefeEwfjUMeta || {},
    component: () => import("/app/pages/support.vue")
  },
  {
    name: "id_old",
    path: "/:id()_old",
    meta: _91id_93_oldd1MyzyBy2QTdm_AbsO9XxpkETcP8DzyOVCb29sgLcmMMeta || {},
    component: () => import("/app/pages/[id]_old.vue")
  },
  {
    name: "blog-max",
    path: "/blog/max",
    component: () => import("/app/pages/blog/max.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    meta: contactskxHN03Gsdgdk5hItUiIn_45VHejdeYe8Yz7_45onvuu94gkMeta || {},
    component: () => import("/app/pages/contacts.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta || {},
    component: () => import("/app/pages/settings.vue")
  },
  {
    name: "creatives",
    path: "/creatives",
    meta: creativesCcwilFM2alSEmMCxaUBSgcH14wtIkvN6Tu4xgpmFjj8Meta || {},
    component: () => import("/app/pages/creatives.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: documentsnySbyr2WnGLxD8HHuPmsjpznGSLSMl3b7IkVDraAXt8Meta || {},
    component: () => import("/app/pages/documents.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    meta: favorites2sDHZ4tGgk4k1D69yU7rUnd6f57vi1WIDQHWhToa0iMMeta || {},
    component: () => import("/app/pages/favorites.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "order",
    path: "/order",
    meta: indexIh3MXyNgRITOpI1vGt16ATsMaILQxMCLyDa1g3F64tcMeta || {},
    component: () => import("/app/pages/order/index.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    meta: _91id_93z_45mKuW1rMZYIKaD_45jb7RkOPiwtU5vi28dxEw6FTfUakMeta || {},
    component: () => import("/app/pages/orders/[id].vue")
  },
  {
    name: "place",
    path: "/place",
    meta: indexolbdBLy3g7xtsrzI2mgg0ddKLEKAVrXPnt4rQtd_KkoMeta || {},
    component: () => import("/app/pages/place/index.vue")
  },
  {
    name: "s-url_old",
    path: "/s/:url()_old",
    meta: _91url_93_oldjgWxgW3eeLF32BR6JiUPM3XDCvaqMrBoeeRg94_ujHcMeta || {},
    component: () => import("/app/pages/s/[url]_old.vue")
  },
  {
    name: "blog-preview",
    path: "/blog/preview",
    meta: previewWYqyYD2oTMwbVyIPiIzmtWIwierP7frgw7UvEvvqpUQMeta || {},
    component: () => import("/app/pages/blog/preview.vue")
  },
  {
    name: "orders",
    path: "/orders",
    meta: indexDCqhPzutOZTeEBErhbpXyxz9LSZCrOqFoLSpaIOOmIIMeta || {},
    component: () => import("/app/pages/orders/index.vue")
  },
  {
    name: "user-confirm",
    path: "/user/confirm",
    component: () => import("/app/pages/user/confirm.vue")
  },
  {
    name: "_orders",
    path: "/_orders",
    meta: index3CFDFRjJsl9ctqYPYF22Gk2o_3mqxoa_9l0TlY2b4CMMeta || {},
    component: () => import("/app/pages/_orders/index.vue")
  },
  {
    name: "creative-id",
    path: "/creative/:id()",
    meta: _91id_933X8Z25xS0KUIdu2rlGSIczgX6SnqvonrtZMgLVlcj4AMeta || {},
    component: () => import("/app/pages/creative/[id].vue")
  },
  {
    name: "dialogs",
    path: "/dialogs",
    meta: indexpSvHlw64TW_BPwpK8c1h6H_fbW0yNr0EE8HM_hg4Zj0Meta || {},
    component: () => import("/app/pages/dialogs/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsB9uD7vf6BNbcGL3D9HpazycZMRkcPWG6ea6_45mQfWSE0Meta || {},
    component: () => import("/app/pages/notifications.vue")
  },
  {
    name: "blog-tag-tag",
    path: "/blog/tag/:tag()",
    meta: _91tag_93q4N3T4f_iz38MTuCeg6TYdTuUhYUWGAaPySsfR9ZBQMMeta || {},
    component: () => import("/app/pages/blog/tag/[tag].vue")
  },
  {
    name: "creative",
    path: "/creative",
    component: () => import("/app/pages/creative/index.vue")
  },
  {
    name: "creative-create",
    path: "/creative/create",
    meta: createBtuz5zgwNAwb4rF0bvPzTxCpp2HfyypdqriW2wDyg5QMeta || {},
    component: () => import("/app/pages/creative/create.vue")
  },
  {
    name: "publisher",
    path: "/publisher",
    meta: indexUGzbRlCPmVAe4lGIxwXECpgBkYjPwkdrBYHUYSsPeykMeta || {},
    component: () => import("/app/pages/publisher/index.vue")
  },
  {
    name: "moderation",
    path: "/moderation",
    meta: indexiLUglNtYLLkYBTgKzOMogJCcAwTQAwliOX032oeizFUMeta || {},
    component: () => import("/app/pages/moderation/index.vue")
  },
  {
    name: "moderation-import",
    path: "/moderation/import",
    meta: importZYrg9WXs0rincSYGAC5rSs_9H9b4Zs9TvWvx7TQGfwkMeta || {},
    component: () => import("/app/pages/moderation/import.vue")
  },
  {
    name: "moderation-orders",
    path: "/moderation/orders",
    meta: ordersTJ5lhRrhxo4tppjn6jK9tY4_45PlFuzNYmOvjABDC7n6gMeta || {},
    component: () => import("/app/pages/moderation/orders.vue")
  },
  {
    name: "publisher-reports",
    path: "/publisher/reports",
    meta: reportsHtzF6M_45xY_458i2RnZKnVGRzA2fOgbEaPy4IbGA1A5QdUMeta || {},
    component: () => import("/app/pages/publisher/reports.vue")
  },
  {
    name: "_orders-id",
    path: "/_orders/:id()",
    meta: indexn_45IvwVXK1Vu7q21IzGfCgxkWV5wV5k93rFwvup2YmnEMeta || {},
    component: () => import("/app/pages/_orders/[id]/index.vue")
  },
  {
    name: "blog-topic",
    path: "/blog/:topic()",
    meta: indexU901K5DcjV_dvHvA3gFJtzxdVo9eXUOochoeglsScCYMeta || {},
    component: () => import("/app/pages/blog/[topic]/index.vue")
  },
  {
    name: "moderation-clients",
    path: "/moderation/clients",
    meta: clients0BJorUMbbEvYq15HRRy_Nx5zCncKTp0QXU2l4DWKT0sMeta || {},
    component: () => import("/app/pages/moderation/clients.vue")
  },
  {
    name: "moderation-support",
    path: "/moderation/support",
    meta: supportMehGf6oaYgppCAzOxOV_r0i3dDpQn9R_45QHpyvbDdKowMeta || {},
    component: () => import("/app/pages/moderation/support.vue")
  },
  {
    name: "publisher-help-faq",
    path: "/publisher/help/faq",
    meta: faqg1pAO7YqXFqKt7XFsc89GHwhwz_45Wf0mPoZ5QKJg0wdQMeta || {},
    component: () => import("/app/pages/publisher/help/faq.vue")
  },
  {
    name: "blog-topic-slug",
    path: "/blog/:topic()/:slug()",
    meta: _91slug_938Rk9ZzJ_fDkeYKZDqJOVvBdGDUOQCqL_45clYr2TrZWEMMeta || {},
    component: () => import("/app/pages/blog/[topic]/[slug].vue")
  },
  {
    name: "moderation-channels",
    path: "/moderation/channels",
    meta: channelsT3VIocaW116Kg0ADfvdQGsNgKQhH4sTsptKUv7A0gccMeta || {},
    component: () => import("/app/pages/moderation/channels.vue")
  },
  {
    name: "moderation-settings",
    path: "/moderation/settings",
    meta: settingsymxf2qVwUUMp5ti_egOwPxuQad5mRQ4CePdjstE3daMMeta || {},
    component: () => import("/app/pages/moderation/settings.vue")
  },
  {
    name: "publisher-documents",
    path: "/publisher/documents",
    meta: documents_45ulmJGPOrCWDHDH42h42o_G2NUlfNVO3SWaJBrgBwEMMeta || {},
    component: () => import("/app/pages/publisher/documents.vue")
  },
  {
    name: "publisher-place_old",
    path: "/publisher/place_old",
    component: () => import("/app/pages/publisher/place_old.vue")
  },
  {
    name: "_group-telegram-id",
    path: "/_group/telegram/:id()",
    component: () => import("/app/pages/_group/telegram/[id].vue")
  },
  {
    name: "moderation-blog-id",
    path: "/moderation/blog/:id()",
    meta: _91id_932NIs7a5h6QK_45L90AU2kQI0NUqPlTztSYcH6cPv6OzLwMeta || {},
    component: () => import("/app/pages/moderation/blog/[id].vue")
  },
  {
    name: "publisher-help",
    path: "/publisher/help",
    meta: indexGNEYi8DKtgjapm5uYfcQ819SwKQy673ZXWphBG6A4EUMeta || {},
    component: () => import("/app/pages/publisher/help/index.vue")
  },
  {
    name: "publisher-place-id",
    path: "/publisher/place/:id()",
    meta: _91id_93f5DjlbIbD_45W_45pSXH0faH01nDVgR9Fi_jeKisvLwsU7oMeta || {},
    component: () => import("/app/pages/publisher/place/[id].vue")
  },
  {
    name: "publisher-places-new",
    path: "/publisher/places/new",
    meta: newrz9bTu80Nhn_cPoSCYnE86BfYKc6VSM77tbQ9QbLHtEMeta || {},
    component: () => import("/app/pages/publisher/places/new.vue")
  },
  {
    name: "publisher-placeScript",
    path: "/publisher/placeScript",
    component: () => import("/app/pages/publisher/placeScript.ts")
  },
  {
    name: "moderation-blog",
    path: "/moderation/blog",
    meta: indexGv1nHhfou4GIGX5gNZ6dfaL3H7kY4_RreyMhVeJmgKIMeta || {},
    component: () => import("/app/pages/moderation/blog/index.vue")
  },
  {
    name: "moderation-publishers",
    path: "/moderation/publishers",
    meta: publishersvAeexi2WNvEASmpN404DWqY0l2ACHbanZMhWlha4UkUMeta || {},
    component: () => import("/app/pages/moderation/publishers.vue")
  },
  {
    name: "moderation-statistics",
    path: "/moderation/statistics",
    meta: statisticsbpVrq1O18hiDWUOB_7JWPbvs0V5ual5DRbty5z5Ssi4Meta || {},
    component: () => import("/app/pages/moderation/statistics.vue")
  },
  {
    name: "publisher-MobilePlace",
    path: "/publisher/MobilePlace",
    component: () => import("/app/pages/publisher/MobilePlace.vue")
  },
  {
    name: "publisher-places-id",
    path: "/publisher/places/:id()",
    meta: _91id_93Zk2eiLyYiQ7E_OFqPzyvRaiNIRromYuWfwy_ltPunGwMeta || {},
    component: () => import("/app/pages/publisher/places/[id].vue")
  },
  {
    name: "moderation-blog-create",
    path: "/moderation/blog/create",
    meta: createqFPXYwW0Kwp0okWKf7i5qfmaBGs5WWL6mSVd7q2A33oMeta || {},
    component: () => import("/app/pages/moderation/blog/create.vue")
  },
  {
    name: "publisher-orders",
    path: "/publisher/orders",
    meta: indextN5BIqHGXBtDuFonHrfZ9ghgDPOEluY37CWqbNDuTdgMeta || {},
    component: () => import("/app/pages/publisher/orders/index.vue")
  },
  {
    name: "publisher-payments_old",
    path: "/publisher/payments_old",
    meta: payments_old0dYMacFkybZ0gX2FlRDRsWB5BgFJDwPt32XuqB9_lXgMeta || {},
    component: () => import("/app/pages/publisher/payments_old.vue")
  },
  {
    name: "publisher-publications",
    path: "/publisher/publications",
    meta: publicationsgfwWaW7dSexGhko9MF2yUJnW9oCs_45Ti0IcxYj6_jzGQMeta || {},
    component: () => import("/app/pages/publisher/publications.vue")
  },
  {
    name: "publisher-showcase-old",
    path: "/publisher/showcase/old",
    component: () => import("/app/pages/publisher/showcase/old.vue")
  },
  {
    name: "moderation-publications",
    path: "/moderation/publications",
    meta: publicationsE_45E0N5dgTdZhiIx_R_45upEkVuBwZz9cZkcV52NIqnS2MMeta || {},
    component: () => import("/app/pages/moderation/publications.vue")
  },
  {
    name: "publisher-dialogs",
    path: "/publisher/dialogs",
    meta: indexzREiHP2_TsMlPdg1F7Iv2H2pptAFVrNTwy97Vo9_VDQMeta || {},
    component: () => import("/app/pages/publisher/dialogs/index.vue")
  },
  {
    name: "publisher-history",
    path: "/publisher/history",
    meta: indexNgs35_JaCzNSO_453Xnhhb7_45NAfWnaBdt8CCZ83BCSDIYMeta || {},
    component: () => import("/app/pages/publisher/history/index.vue")
  },
  {
    name: "publisher-places-old-id",
    path: "/publisher/places/old-id",
    meta: old_45idQ_45jFFVhKy9Myc_45kRvS3idq8ohJbZ0K6I9FvEYKe2sL8Meta || {},
    component: () => import("/app/pages/publisher/places/old-id.vue")
  },
  {
    name: "publisher-payments",
    path: "/publisher/payments",
    meta: index4CRes96f_ra5Nmtye_45Ede0lRjWotGmRQNt8U7wg_ARsMeta || {},
    component: () => import("/app/pages/publisher/payments/index.vue")
  },
  {
    name: "publisher-settings",
    path: "/publisher/settings",
    meta: indexc5LIbfF4Qy_swRc1d5HVVew6QKYqqr0lfoVGFG1YA0sMeta || {},
    component: () => import("/app/pages/publisher/settings/index.vue")
  },
  {
    name: "publisher-showcase",
    path: "/publisher/showcase",
    meta: indexkDPyChnYWolx9oP4JndGYB0CxLNse3ONY_45rj3qsePgoMeta || {},
    component: () => import("/app/pages/publisher/showcase/index.vue")
  },
  {
    name: "publisher-showcase-public",
    path: "/publisher/showcase/public",
    meta: publicS2Lj7zu_45D7BBjYp6ykDlHmsCE6ZhAhMQG9OsJfhUJ7QMeta || {},
    component: () => import("/app/pages/publisher/showcase/public.vue")
  },
  {
    name: "publisher-showcase-index_old",
    path: "/publisher/showcase/index_old",
    meta: index_oldJ3Js1tlNsFuqAtOQn6GZ9otTAYu1EFDTZrSbiWs9ZTMMeta || {},
    component: () => import("/app/pages/publisher/showcase/index_old.vue")
  },
  {
    name: "publisher-places-moderate-id",
    path: "/publisher/places/moderate/:id()",
    meta: _91id_93P2H4TrB53Lv44xyYMsh6sBz5mCJgZg22L_pVR7ydRRUMeta || {},
    component: () => import("/app/pages/publisher/places/moderate/[id].vue")
  }
]